import React from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "reactstrap";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

import logo from "../../assets/img/logo.jpg";

var ps;

function Sidebar(props) {
  const sidebar = React.useRef();
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  });
  return (
    <div
      className="sidebar"
      data-color={props.bgColor}
      data-active-color={props.activeColor}
    >
      <div className="logo">
        <a
          href="https://mydzstore.com"
          className="simple-text logo-mini"
        >
          <div className="logo-img">
            <img src={logo} alt="mdzs-logo" style={{ borderRadius: 20 }} />
          </div>
        </a>
        <a
          href="https://mydzstore.com"
          className="simple-text logo-normal"
        >
          MyDzStore
        </a>
      </div>
      <div className="sidebar-wrapper" ref={sidebar}>
        <Nav>
          {props.routes.map((prop, key) => {
            return (
              prop.display !== false &&
              <li
                className={
                  activeRoute(prop.path) + (prop.pro ? " active-pro" : "")
                }
                key={key}
              >
                <NavLink
                  to={prop.path}
                  className="nav-link"
                  activeClassName="active"
                >
                  <i className={prop.icon} />
                  {
                    activeRoute(prop.path) === "active" ? (props.lang === "ar" ? <p style={{ fontSize: 22 }}><b>{prop.name_ar}</b></p> : <p><b>{prop.name}</b></p>) : (props.lang === "ar" ? <p style={{ fontSize: 22 }}>{prop.name_ar}</p> : <p>{prop.name}</p>)
                  }

                </NavLink>
              </li>
            );
          })}
        </Nav>
      </div>
    </div>
  );
}

export default Sidebar;
